import { render, staticRenderFns } from "./IntervenantRegister.vue?vue&type=template&id=20ad4625&scoped=true&"
import script from "./IntervenantRegister.vue?vue&type=script&lang=js&"
export * from "./IntervenantRegister.vue?vue&type=script&lang=js&"
import style0 from "./IntervenantRegister.vue?vue&type=style&index=0&id=20ad4625&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad4625",
  null
  
)

export default component.exports